import { Component, Vue } from 'vue-property-decorator'
import CBAG1020Service from '../CBAG1020/CBAG1020Service'
import CBAG1030ViewModel from './CBAG1030ViewModel'
import { FormatConstants } from '@/common/FormatConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import CommonConstants from '@/common/CommonConstants'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import Numeral from 'numeral'
@Component({
  name: 'CBAG1030',
  components: {}
  })
export default class CBAG1030Controller extends Vue {
  private cbag1020Service = new CBAG1020Service()
  private FormatConstants = FormatConstants
  private CommonConstants = CommonConstants
  private RK_CONTRACT_CODE = '9000101'
  private cbag1030ViewModel: CBAG1030ViewModel = {
    notPrncpSecrTypLst: [
      {
        productName: '',
        operatCmpny: '',
        productDiv: '',
        operatMethod: '',
        feeTrustRewd: '',
        feeTrustPropertyReservesPric: '',
        descFilesUrl: '',
        operatRptUrl: '',
        trustRewdShhnFlg: '',
        productRName: '',
        pensionFundTrustProductFlag: '',
        rtnOneYear: '',
        rtnCritMon: '',
        critVal: '',
        critValBeforeDayCompre: '',
        critValCritDay: ''
      }
    ],
    prncpSecrTypLst: [
      {
        productNameFormalName: '',
        operatCmpny: '',
        productDiv: '',
        midCancelDeductExist: '',
        descFilesUrl: '',
        investPerformUrl: '',
        productRName: '',
        productCategory: '',
        appRate: '',
        appPeriodCritMon: '',
        appPeriodCritStartDay: '',
        appPeriodCritEndDay: ''
      }
    ],
    persnPlanDescPdfInfo: {
      persnPlanDescPdfName: '',
      persnPlanDescPdfUrl: ''
    },
    operatProductSelReasonPdfInfo: {
      operatProductSelReasonPdfName: '',
      operatProductSelReasonPdfUrl: ''
    },
    tabActive: 1,
    batchDispDiv: ''
  }

  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.$nextTick(() => {
      fixedContentNoLogin()
    })
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const cbag1020ResponseModel = await this.cbag1020Service.callAPICBAA1020(
      this.RK_CONTRACT_CODE
    )
    if (cbag1020ResponseModel.notPrncpSecrTypLst) {
      this.cbag1030ViewModel.notPrncpSecrTypLst =
        cbag1020ResponseModel.notPrncpSecrTypLst.map((item) => {
          if (item.feeTrustRewd) {
            const feeTrustRewd = CommonUtil.roundNumber(
              item?.feeTrustRewd,
              FormatConstants.ANNUAL_RATE_FIVE_DIGITS
            )
            item.feeTrustRewd =
              feeTrustRewd !== null
                ? feeTrustRewd.toFixed(5)
                : item.feeTrustRewd
          }
          if (item.rtnOneYear) {
            const rtnOneYear =
              item.pensionFundTrustProductFlag === '1'
                ? item.rtnOneYear
                : Numeral(item.rtnOneYear).multiply(100).value()
            item.rtnOneYear = CommonUtil.roundNumber(
              rtnOneYear,
              FormatConstants.INVEST_WITHOUT_UNIT
            )
          }
          return {
            ...item
          }
        })
    } else {
      this.cbag1030ViewModel.notPrncpSecrTypLst = null
    }

    if (cbag1020ResponseModel.prncpSecrTypLst !== null) {
      this.cbag1030ViewModel.prncpSecrTypLst =
        cbag1020ResponseModel.prncpSecrTypLst
    } else {
      this.cbag1030ViewModel.prncpSecrTypLst = null
    }

    if (CommonUtil.isNotEmpty(cbag1020ResponseModel.persnPlanDescPdfInfo)) {
      this.cbag1030ViewModel.persnPlanDescPdfInfo =
        cbag1020ResponseModel.persnPlanDescPdfInfo
    }

    if (
      CommonUtil.isNotEmpty(cbag1020ResponseModel.operatProductSelReasonPdfInfo)
    ) {
      this.cbag1030ViewModel.operatProductSelReasonPdfInfo =
        cbag1020ResponseModel.operatProductSelReasonPdfInfo
    }
    this.cbag1030ViewModel.batchDispDiv = cbag1020ResponseModel.batchDispDiv
  }

  /**
   * 運用の方法の公表（個人型）（ミライデコ）（CBAG1040）画面に遷移する
   */
  private gotoCBAG1040() {
    this.$router.push({ name: 'cbag1040' })
  }

  /**
   * 運用の方法の公表（個人型）（第一生命の個人型Vプランα）（CBAG1020）画面に遷移する
   */
  private gotoCBAG1020() {
    this.$router.push({ name: 'cbag1020' })
  }

  /**
   * タブを変更
   * @param 選択したタブ
   */
  private changeTab(tab: number) {
    if (this.cbag1030ViewModel.tabActive !== tab) {
      this.cbag1030ViewModel.tabActive = tab
    }
  }

  /**
   * PDFのURLを別タブで開く。
   * @param 開くPDFファイルのURL
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * ログイン（CAAG1010）画面に遷移する。
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
